import { InfoPageNavItem } from "utils/fetchInfoPageNavItems";
import { NavigationContextInterface, NavigationSetParam } from "types/tags";

export function useNavigationProvider(
  navigationSetsParam?: NavigationSetParam[],
  infoPageNavItems: InfoPageNavItem[] = []
): {
  navigationContextValue: NavigationContextInterface;
} {
  const navigationContextValue: NavigationContextInterface = {
    navigationSets: navigationSetsParam ?? [],
    infoPageNavItems,
  };

  return { navigationContextValue };
}
